import React, { FC } from 'react'

import { FormattedMessage } from 'react-intl'
import styled from 'styled-components'

import { Colors } from 'common-constants/colors'
import {
  FontCss,
  FontCssProps,
} from 'components/presentational/title/PlainTitle'

export const ProfileNameDeleted: FC<{
  fontSize?: number
  boldText?: boolean
  commonColor?: Colors
}> = ({ fontSize = 16, boldText = true, commonColor = Colors.black }) => {
  return (
    <ProfileName fontSize={fontSize} boldText={boldText} color={commonColor}>
      <FormattedMessage
        id="app.account_deleted"
        defaultMessage="Анкета удалена"
      />
    </ProfileName>
  )
}

export const ProfileName = styled.div<FontCssProps>`
  ${FontCss};
`
